import React from "react";
import Cards from "./Cards";

// Utility function to expand category names
const expandCategoryName = (name) => {
  const categories = [
    {
      title: "Income Tax",
      description: "Income Tax",
    },
    {
      title: "GST",
      description: "GST (Goods and Services Tax)",
    },
    { title: "NG", description: "TaxUpdates NG" },
    {
      title: "Professional",
      description: "Professional Tax",
    },
    { title: "TDS", description: "TDS (Tax Deducted at Source)" },
    { title: "TCS", description: "TCS (Tax Collected at Source)" },
  ];

  const category = categories.find(
    (cat) => cat.title.toLowerCase() === name.toLowerCase()
  );
  return category ? category.description : name;
};

function CategoryPage({ data, records }) {
  // Expand the category name
  const expandedCategoryName = expandCategoryName(data);

  console.log(records);

  // Filter records by category
  const categoryBlogs = records.filter(
    (blog) => blog.category === expandedCategoryName
  );

  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">
        Category Page: <span className="text-[#151C62]">{data}</span>
      </h1>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        <Cards posts={categoryBlogs} />
      </div>
    </div>
  );
}

export default CategoryPage;
